(function () {

    angular
        .module('smartertoolsApp')
        .factory('notificationFactory', [notificationFactory]);

    function notificationFactory() {
        return {
            success: (text) => showToast('toast-success', text),
            error: (text) => showToast('toast-error', text)
        };

        function showToast(classname, message) {
            let container = document.getElementById('ToastContainer');
            if (!container) {
                container = document.createElement('div');
                container.id = 'ToastContainer';
                container.classList.add('toast-container');
                document.body.appendChild(container);
            } else {
                container.innerHTML = '';
            }

            let toast = document.getElementById('liveToast');
            if (!toast) {
                toast = document.createElement('div');
                toast.id = 'liveToast';
                toast.classList.add('toast', 'show');
                toast.setAttribute('role', 'alert');
                toast.setAttribute('aria-live', 'assertive');
                toast.setAttribute('aria-atomic', 'true');
                container.appendChild(toast);
            } else {
                toast.innerHTML = '';
            }
            toast.classList.remove('toast-error', 'toast-success');
            toast.classList.add(classname);

            let flexDiv = document.createElement('div');
            flexDiv.classList.add('d-flex');
            toast.appendChild(flexDiv);

            let divBody = document.createElement('div');
            divBody.classList.add('toast-body');
            divBody.innerText = message;
            flexDiv.appendChild(divBody);

            let divButton = document.createElement('div');
            divButton.setAttribute('type', 'button');
            divButton.classList.add('btn-close');
            divButton.setAttribute('data-bs-dismiss', 'toast');
            divButton.setAttribute('aria-label', 'Close');
            flexDiv.appendChild(divButton);

            $('#ToastContainer').toast('show');
        }
    }

})();
